import Modal from 'react-modal';

const initModal = () => {
    Modal.setAppElement('#__next');
};

export default initModal;
